import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getGymnastData } from "../actions/action_gymnast";
import { setGymnastShowLoader } from "../actions/action_gymnast";

class Gymnast extends Component {
  constructor(props) {
    let columns = [
      {Header: 'Date', accessor: 'date'},
      {Header: 'Opponent', accessor: 'opponent'},
      {Header: 'Desc', accessor: 'meet_desc'},
      {Header: 'FX', accessor: 'floor',
      Cell: props => this.getVideoLink(props.original.fx_url, props.original.floor)
      },
      {Header: 'PH', accessor: 'phorse',
      Cell: props => this.getVideoLink(props.original.ph_url, props.original.phorse)
      },
      {Header: 'SR', accessor: 'rings',
      Cell: props => this.getVideoLink(props.original.sr_url, props.original.rings)
      },
      {Header: 'VT', accessor: 'vault',
      Cell: props => this.getVideoLink(props.original.vt_url, props.original.vault)
      },
      {Header: 'PB', accessor: 'pbars',
      Cell: props => this.getVideoLink(props.original.pb_url, props.original.pbars)
      },
      {Header: 'HB', accessor: 'highbar',
      Cell: props => this.getVideoLink(props.original.hb_url, props.original.highbar)
      },
      {Header: 'AA', accessor: 'all_around'},
      {
        Header: 'Home/Away',
        accessor: 'home',
        Cell: props => <span>{Number(props.value) === 0 ? "A" : "H"}</span>
      }
     ];
    super(props);
    this.state = {
      cols: columns
    };
  }
  getVideoLink(url, val) {
    let num = Number(val) !== 0 ? Number(val).toFixed(4) : null;
    if(url!== null) {
      return <a className="meetLink" href={'https://www.youtube.com/watch?v='+url} data-lity>{num}</a>;
    } else {
      return num;
    }
  }
  componentDidUpdate(prevProps){
    if(this.props.showLoader === false) {
      if(prevProps.gymnastFilter !== this.props.gymnastFilter || prevProps.yearFilter !== this.props.yearFilter){
        this.props.getGymnastData({
          gymnast: this.props.gymnastFilter,
          year: this.props.yearFilter
        });
      }
    }
  }
  render() {
    if(!this.props.showLoader) {
      if(this.props.meets !== undefined){
        return (
          <div>
            <h3>{this.props.team.fname2} {this.props.team.lname} - {this.props.team.team_name}</h3>
            <ReactTable
              className="-striped -highlight"
              data={this.props.meets}
              columns={this.state.cols}
              showPagination={false}
              defaultPageSize={this.props.numRows}
              pageSize={this.props.numRows}
            />
          </div>
        );
      } else {
        return <div></div>;
      }
    } else {
      return <Loader />;
    }
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    gymnastFilter: state.main.gymnastFilter,
    team: state.gymnast.team,
    meets: state.gymnast.meets,
    numRows: state.gymnast.numRows,
    showLoader: state.gymnast.showLoader
  };
}

export default connect(mapStateToProps, { getGymnastData, setGymnastShowLoader })(Gymnast);
